import CustomSVG from "../svg";
import classes from "./featured_icon.module.css";

export default function FeaturedIcon({color, size, icon, outline, theme, square, border}) {
    let icon_size;
    switch(size) {
        case "xs": icon_size = 12; break;
        case "sm": icon_size = 16; break;
        case "md": icon_size = 20; break;
        case "lg": icon_size = 24; break;
        case "xl": icon_size = 28; break;
        default: icon_size = 20;
    }

    let temp_icon;
    if(typeof icon === "string") {
        temp_icon = <i className={`bi bi-icon bi-icon-${icon_size} ${icon}`}/>
    } else {
        temp_icon = <CustomSVG SvgFunction={icon} height={icon_size} width={icon_size} />
    }

    return <div className={`${classes.icon} ${classes[size]} ${classes[color]} ${outline ? classes.outline : ""} ${theme ? classes[theme] : ""} ${square ? classes.square : ""} ${border ? classes.border : ""}`}>
        {temp_icon}
    </div>
}